<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <div style="max-width: 640px;">
      <h1 class="px-4 text-primary fade-in-up-enter-active animation-slowest">Wensen</h1>
      <h5 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200">Wat kan er verbeterd worden?</h5>

      <base-card class="w-100" inner-class="vw-100" color="alternate" :outer-padding="true">
        <base-form @submit="onSubmit">
          <button-grid-input
            name="Wishes"
            btn-direction="row"
            type="checkbox"
            btn-class="min-40"
            :pairs-mode="true"
            :distribute-equally="true"
            :options="wishOptions"
            variant="minimal-filled-info"
            inactiveVariant="minimal-dark"
            v-model:value="lead.wishes.Wishes"
            @update:value="updateWishes"
          >
            Kies de maatregelen waar de bewoner interesse in heeft:
          </button-grid-input>

          <!-- Add description for maatregel -->
          <base-card
            color="light"
            class="mt-4 w-100"
            inner-class="p-3 w-100"
          >
          <h6 class="mb-3 text-primary">Algemene toelichting</h6>
            <base-input
              type="textarea"
              name="algemene-toelichting"
              id="algemene-toelichting"
              v-model:value="lead.wishes.WishNotes['Algemene_toelichting']"
              :rows="3"
              :min-rows="3"
              :autosize="true"
              :input-class="'form-control w-100 border-color-secondary'"
              :placeholder="'Geef hier een korte toelichting'"
            />
            <div v-if="lead.wishes.Wishes && lead.wishes.Wishes.length > 0">

              <h6 class="mb-3 text-primary">Toelichting per maatregel</h6>
              <div
                v-for="wish in lead.wishes.Wishes"
                :key="wish"
                class="mb-2"
              >
                <label :for="'note-' + normalizeKey(wish)" class="fw-500 mb-2 text-secondary d-block">
                  <span v-html="getWishLabel(wish)"></span>
                </label>
                <base-input
                  type="textarea"
                  :name="'note-' + normalizeKey(wish)"
                  :id="'note-' + normalizeKey(wish)"
                  v-model:value="lead.wishes.WishNotes[normalizeKey(wish)]"
                  :rows="3"
                  :min-rows="3"
                  :autosize="true"
                  :input-class="'form-control w-100 border-color-secondary'"
                  :placeholder="'Geef hier een korte toelichting'"
                />
              </div>
            </div>
          </base-card>

          <button-row class="mt-5">
            <base-button class="ms-auto" icon="bi-arrow-right" type="submit" :disabled="v$.wishes.$invalid">Volgende</base-button>
          </button-row>
        </base-form>
      </base-card>

      <button-row class="mt-2">
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue";
  import BaseCard from "@/components/BaseCard.vue";
  import BaseForm from "@/components/BaseForm.vue";
  import BaseButton from "@/components/BaseButton.vue";
  import ButtonRow from "@/components/ButtonRow.vue";
  import ButtonGridInput from "@/components/ButtonGridInput.vue";
  import BaseInput from "@/components/BaseInput.vue";

  import { useAllStores } from "@/helpers/UseAllStores";
  import { CommonComposable } from "@/helpers/CommonComposable";
  import { FlowService } from "@/services/FlowService";
  import { getInterestDefinitions } from "@/rules/InterestDefinitions";

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseButton,
      ButtonRow,
      ButtonGridInput,
      BaseInput,
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        maxCols: 1,
        btnDirection: 'column'
      };
    },
    computed: {
      wishOptions() {
        return getInterestDefinitions(
          this.lead.meta.AllInterestsEnabled,
          this.lead.meta.InterestWhiteList
        );
      },
    },
  methods: {
      normalizeKey(key) {
        const option = this.wishOptions.find(opt => opt.value === key);
        let text = option ? option.label : key;
        text = String(text).replace(/<[^>]*>/g, '').trim();
        return text.replace(/\s+/g, '_').replace(/[^\w-]/g, '');
      },
      updateWishes(selectedValues) {
        const sortedValues = this.wishOptions
          .map((option) => option.value)
          .filter((value) => selectedValues.includes(value));

        this.lead.wishes.Wishes = sortedValues;

        const updatedNotes = { ...this.lead.wishes.WishNotes };
        sortedValues.forEach((value) => {
          const normalizedKey = this.normalizeKey(value);
          if (!(normalizedKey in updatedNotes)) {
            updatedNotes[normalizedKey] = "";
          }
        });
        this.lead.wishes.WishNotes = updatedNotes;
      },
      // Remove notes without maatregel and remove empty notes
      cleanWishNotes() {
        const cleanedNotes = {};
        const existingNotes = this.lead.wishes.WishNotes

        const generalKey = this.normalizeKey('Algemene toelichting');

        if (existingNotes[generalKey]?.trim() !== "") {
          cleanedNotes[generalKey] = existingNotes[generalKey];
        }

        this.lead.wishes.Wishes.forEach((wish) => {
          const normalizedKey = this.normalizeKey(wish);
          if (existingNotes[normalizedKey]?.trim() !== "") {
            cleanedNotes[normalizedKey] = existingNotes[normalizedKey];
          }
        });

        this.lead.wishes.WishNotes = cleanedNotes;
      },
      getWishLabel(value) {
        const option = this.wishOptions.find((opt) => opt.value === value);
        return option ? option.label : value;
      },
      touchAndValidate() {
        this.v$.wishes.$touch();
        return !this.v$.wishes.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          this.cleanWishNotes();
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      },
      breakPoints() {
        if (window.innerWidth > 550) {
          this.maxCols = null;
          this.btnDirection = 'column';
        } else {
          this.maxCols = 1;
          this.btnDirection = 'row';
        }
      },
    },
    beforeRouteUpdate() {
      this.breakPoints();
    },
    mounted() {
      this.breakPoints();
      window.addEventListener("resize", this.breakPoints);
    },
    unmounted() {
      window.removeEventListener("resize", this.breakPoints);
    },
  };
</script>